import { render } from "./PatchNotes.vue?vue&type=template&id=5d3d8a3a&scoped=true"
import script from "./PatchNotes.vue?vue&type=script&lang=js"
export * from "./PatchNotes.vue?vue&type=script&lang=js"

import "./PatchNotes.vue?vue&type=style&index=0&id=5d3d8a3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3d8a3a"]])

export default __exports__